import React, { Fragment, useState } from 'react';
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Paper,
  Button,
} from '@mui/material';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import logger from 'utils/logger';
import { zIndexValues } from 'utils/styles';

const log = logger.createLogger('ReportSelection');

const ReportSelection = ({ selectionList, title, onSelect, onClose }) => {
  const [selectedReport, setSelectedReport] = useState('');
  const handleSelectChange = (event) => {
    setSelectedReport(event.target.value);
  };

  return (
    <Fragment>
      <Paper
        sx={{
          width: '650px',
          padding: 5,
        }}>
        <Typography variant="h6" gutterBottom sx={{ marginBottom: 2 }}>
          {title}
        </Typography>
        <FormControl fullWidth>
          <InputLabel>
            {intl.get('issue_details_report_editor_button_select_option')}
          </InputLabel>
          <Select
            value={selectedReport}
            onChange={handleSelectChange}
            MenuProps={{
              sx: {
                zIndex: zIndexValues.modal4 + 1, // Set higher than modal
              },
            }}
            label={intl.get(
              'issue_details_report_editor_button_select_option'
            )}>
            {selectionList.map((report) => (
              <MenuItem key={report.id} value={report.id}>
                {report.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box mt={2} display="flex" justifyContent="space-between">
          <Button
            onClick={() =>
              onSelect(
                selectionList.find((report) => report.id === selectedReport)
              )
            }
            variant="contained"
            sx={{
              justifyContent: 'start',
              color: '#fff',
            }}
            disabled={!selectedReport}>
            {intl.get(
              'issue_details_report_editor_button_select_option_confirm'
            )}
          </Button>
          <Button
            variant="contained"
            sx={{
              justifyContent: 'start',
              color: '#fff',
              backgroundColor: '#E13C3C',
              '&:hover': {
                backgroundColor: '#f65f53',
              },
            }}
            onClick={onClose}>
            {intl.get(
              'issue_details_report_editor_button_select_option_cancel'
            )}
          </Button>
        </Box>
      </Paper>
    </Fragment>
  );
};

ReportSelection.propTypes = {
  selectionList: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ReportSelection;
